import React, {Component} from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText, MenuItem, Select
} from '@material-ui/core';
import {Close, Done} from '@material-ui/icons'
import localization from '../../config/localization';
import {request} from '../../api-client';
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import TranslatableInputs from "../../components/Letflow/TranslatableInputs";
import {checkDataSourcesAgainstPermissions, dataSourceTypes} from "./HomeGridAndCarouselBase";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../components/Letflow/Snackbar/GlobalSnackbar";
import {SelectValidator} from "../../components/Letflow/Form";
import AsyncSelect from "react-select/lib/Async";
import HomeElementCreateDialogTagSelection from "./HomeElementCreateDialogTagSelection";
import {Radio, RadioGroup} from "@material-ui/core/index";
import HomeElementStyleSelection from "./HomeElementStyleSelection";


const updateTagGroups = (tagGroups, selectedTags, unselectedTags) => {
  return tagGroups.map(tagGroup => ({
    ...tagGroup,
    tags: tagGroup.tags.map(tag => ({
      ...tag,
      state: selectedTags.find(selectedTag => selectedTag.toString() === tag.id.toString()) ?
        'selected'
        : unselectedTags.find(selectedTag => selectedTag.toString() === tag.id.toString()) ? 'unselected'
          :'available'
    }))
  }))
}

class HomeElementCreateDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      type: props.type || '',
      submitting: false,
      rowsToShow: 4,
      columns: 4,
      titleEs: '',
      titleEn: '',
      titlePt: '',
      includeGold: false,
      dataSource: '',
      dataSourceTypes: dataSourceTypes,
      onlyImage: false,
      fixedTitle: false,
      withBackground: false,
      numbered: false,
      catalogs: [],
      contentCreatorType: null,
      tagGroups: [],
      selectedTags: [],
      unselectedTags: [],
      tagsAlreadyRequested: false,
      selectedContentCreatorTypes: [],
      link: "",
      isCreating: props.isCreating || false,
      shape: props.shape || '',
      navbarViewType: "grid",
      parent: props.parent || null,
      featuredType: props.inverted ? 'inverted' : props.editorial ? 'editorial' : 'default',
      availablePlaylists: props.availablePlaylists || [],
      playlist: (props.playlist_id && props.availablePlaylists) ? props.availablePlaylists.find(item => item.value === props.playlist_id) : null,
    }
  }

  componentDidMount = () => {
    this.setState({dataSourceTypes: checkDataSourcesAgainstPermissions(dataSourceTypes, this.props.parent, this.props.isNavbar )})
  }

  clearAllTags = () =>
    new Promise(resolve => {
      this.setState( {tagGroups: this.state.tagGroups.map(tagGroup => {
          return {...tagGroup,
            tags: tagGroup.tags.map(tag => {
                return {...tag, state: 'available'}
            })
          }
        })
      })
      resolve()
    }).then(() => this.setState({selectedTags: [], unselectedTags: []}))


  componentDidUpdate = (prevProps, prevState) => {
    if ((this.state.dataSource === 'content_creator_talent' || this.state.dataSource === 'content_creator_audiovisual') && (prevState.contentCreatorType !== this.state.contentCreatorType)) {
      request.tagGroup.getAll({filterBy: [{ column: 'type', filter: this.state.contentCreatorType}, { column: 'creation_group', filter: '0'}]})
        .then(tags => this.setTagGroups(tags))
    }

    if (this.state.dataSource === 'video_content_creation' && (prevState.selectedContentCreatorTypes !== this.state.selectedContentCreatorTypes)) {
      request.tagGroup.getAll({filterBy: [
          { column: 'types_ids', filter: this.state.selectedContentCreatorTypes.map(type => type.value)},
        ]})
        .then(tags => this.setTagGroups(tags))
    }
  }

  setTagGroups = tagGroups => this.setState(state => ({...state, tagGroups}))

  updateTagColor = (selectedTag, value) =>
    this.setState( {tagGroups: this.state.tagGroups.map(tagGroup => {
          return {...tagGroup,
            tags: tagGroup.tags.map(tag => {
                if (tag.id === selectedTag) {
                  return {...tag, state: value}
                }
                return tag
              })
            }
          }
        )
      })

  onSelectedTagsChanged = selectedTag => {
    if (this.state.selectedTags.includes(selectedTag)) { //Remove from selected / add to unselected tags
      this.state.unselectedTags.push(selectedTag)
      this.setState({
        selectedTags: this.state.selectedTags.filter(tags => tags !== selectedTag),
        unselectedTags: this.state.unselectedTags
        }, () => this.updateTagColor(selectedTag, "unselected"))
    }else if(this.state.unselectedTags.includes(selectedTag)) { //Remove from unselected / add to available tags
      this.setState({
        unselectedTags: this.state.unselectedTags.filter(tags => tags !== selectedTag),
      }, () => this.updateTagColor(selectedTag, "available"))
    }else { //Remove from available / add to selected tags
      this.state.selectedTags.push(selectedTag);
      this.setState({selectedTags: this.state.selectedTags}, () => this.updateTagColor(selectedTag, "selected"))
    }
  };

  onTagsTest = () =>
    request.home.test({
        type: this.state.dataSource,
        selectedTags: this.state.selectedTags,
        unselectedTags: this.state.unselectedTags,
        content_creator_type: this.state.contentCreatorType,
        content_creators_ids: this.state.selectedContentCreatorTypes.map(selectedContentCreatorType => selectedContentCreatorType)
      }
    )

  handleCancel = () => {
    this.props.onClose('cancel')
  }

  handleSubmit = () => {
    if (!this.state.type) {
      GlobalSnackbar.show({
        message: localization.get('home_editor.validate_type'),
        type: GlobalSnackbarTypes.ERROR,
      })
    } else {
      this.setState({ submitting: true })
      request.home.create({
          order: this.props.order,
          type: this.state.type,
          titleEs: this.state.titleEs,
          titleEn: this.state.titleEn,
          titlePt: this.state.titlePt,
          dataSource: this.state.dataSource === 'content_creator_talent' || this.state.dataSource === 'content_creator_audiovisual' ? 'content_creator' : this.state.dataSource,
          includeGold: this.state.includeGold,
          rowsToShow: this.state.rowsToShow,
          columns: this.state.columns,
          onlyImage: this.state.onlyImage,
          contentCreatorType: this.state.contentCreatorType,
          selectedTags: this.state.selectedTags,
          unselectedTags: this.state.unselectedTags,
          selectedContentCreatorTypes: this.state.selectedContentCreatorTypes,
          link: this.state.link,
          isCreating: false,
          shape: this.state.shape,
          fixedTitle: this.state.fixedTitle,
          withBackground: this.state.withBackground,
          numbered: this.state.numbered,
          navbarViewType: this.state.navbarViewType,
          parent: this.state.parent,
          featuredType: this.state.featuredType,
          playlist: this.state.playlist && this.state.playlist.value,
          sectionId: this.props.sectionId,
          section: this.state.section,
        }
      )
        .then(response => {
          this.setState({ submitting: false })
          if(this.state.isCreating) {
            response.data.title = response.data.translations.filter(trans => trans.title)[0].title

            this.props.addElement(response.data)
            this.props.onClose('success')
          } else {
            this.props.onClose('success')
          }
          GlobalSnackbar.show({
            message: localization.get('home_editor.element_created'),
            type: GlobalSnackbarTypes.SUCCESS,
          })
        })
        .catch(error => {
          this.setState({ submitting: false })
          GlobalSnackbar.show({
            message: localization.get('home_editor.element_update_failed'),
            type: GlobalSnackbarTypes.ERROR,
          })
        })
    }
  }

  onChange = e => {
    this.setState({[e.target.id || e.target.name]: e.target.value})
    if ( e.target.name !== 'columns' && e.target.name !== 'rowsToShow') {
      this.setState({columns: 4, rowsToShow: 4})
    }
  }

  render = () => {
    return (
      <Dialog maxWidth={false} open={true} onEscapeKeyDown={this.handleCancel}>
        <ValidatorForm style={{width: 675, maxWidth: '100%'}} onSubmit={this.handleSubmit}>
          <DialogTitle>{localization.get((this.state.creatingElements) ? 'create_navbar_button' : 'create_home_element')}</DialogTitle>
          <DialogContent>
            {this.state.type !== "banner" &&
            <FormControl id="content" style={{width: '100%'}}>
              <TranslatableInputs
                ref={instance => this.child = instance}
                children={[
                  {
                    language: 'es',
                    content: [
                      <TextValidator
                        style={{width: "100%", marginBottom: "20px"}}
                        id="titleEs"
                        label={localization.get('home_editor.title')}
                        name="titleEs"
                        value={this.state.titleEs}
                        onChange={this.onChange}
                      />
                    ]
                  },
                  {
                    language: 'en',
                    content: [
                      <TextValidator
                        style={{width: "100%", marginBottom: "20px"}}
                        id="titleEn"
                        label={localization.get('home_editor.title')}
                        name="titleEn"
                        value={this.state.titleEn}
                        onChange={this.onChange}
                      />
                    ]
                  },
                  {
                    language: 'pt',
                    content: [
                      <TextValidator
                        style={{width: "100%", marginBottom: "20px"}}
                        id="titlePt"
                        label={localization.get('home_editor.title')}
                        name="titlePt"
                        value={this.state.titlePt}
                        onChange={this.onChange}
                      />
                    ]
                  }
                ]}
              />
              {this.state.type !== 'navbar' ?
                <div>
                  <span>{localization.get("form.type")}</span>
                  <RadioGroup
                    name="type"
                    value={this.state.type}
                    onChange={this.onChange}
                    style={{width: "100%", float: "left", position: "relative", flexDirection: "row"}}
                  >
                    <FormControlLabel value="grid" control={<Radio color="default"/>} label={localization.get('select.grid')}/>
                    <FormControlLabel value="carousel" control={<Radio color="default"/>} label={localization.get('select.carousel')}/>
                    <FormControlLabel value="featured" control={<Radio color="default"/>} label={localization.get('select.featured')}/>
                  </RadioGroup>
                </div>
              :
              (this.state.dataSource === "content_creator_audiovisual" || this.state.dataSource === "content_creator_talent") &&
              <React.Fragment>
                <br/>
                <Select
                  name='navbarViewType'
                  value={this.state.navbarViewType}
                  onChange={this.onChange}
                  disabled={true}
                >
                  <MenuItem value={"grid"} selected>{localization.get('select.grid')}</MenuItem>
                </Select>
                <FormHelperText>{localization.get('content_creator_type')}</FormHelperText>
              </React.Fragment>
              }

              {((this.state.type && this.state.type !== 'navbar') || (this.state.type === 'navbar' &&
                (this.state.dataSource === "content_creator_audiovisual" || this.state.dataSource === "content_creator_talent"))) &&
                <HomeElementStyleSelection
                  type={this.state.type !== 'navbar' ? this.state.type : this.state.navbarViewType}
                  shape={this.state.shape}
                  fixedTitle={this.state.fixedTitle}
                  withBackground={this.state.withBackground}
                  numbered={this.state.numbered}
                  onlyImage={this.state.onlyImage}
                  columns={this.state.columns}
                  rowsToShow={this.state.rowsToShow}
                  onChange={this.onChange}
                  featuredType={this.state.featuredType}
                  onCheckboxChange={name => this.setState({[name]: !this.state[name]})}
                />
              }

              <SelectValidator
                name="dataSource"
                current={this.state.dataSource}
                title={localization.get('home_editor.data_source')}
                onChange={this.onChange}
                items={
                  this.state.dataSourceTypes
                  .map((dataSourceType) => ({id: dataSourceType.value, name: dataSourceType.label }))
                }
                disabled={false}
                validators={["required"]}
                errorMessages={[localization.get("validator.is_required")]}
              />

              {(this.state.dataSource === 'content_creator_talent' || this.state.dataSource === 'content_creator_audiovisual') &&
                <React.Fragment>
                  <br/>
                  <Select
                    name='contentCreatorType'
                    value={this.state.contentCreatorType}
                    onChange={this.onChange}
                  >
                    {
                      this.props.contentCreatorTypes
                        .sort((a, b) => (a.label > b.label) ? 1 : -1)
                        .map((contentCreatorType, i) => {
                          if (this.state.dataSource === 'content_creator_talent' && !contentCreatorType.isTalent) {
                            return false
                          }
                          if (this.state.dataSource === 'content_creator_audiovisual' && contentCreatorType.isTalent) {
                            return false
                          }

                          return (
                            <MenuItem key={i} value={contentCreatorType.value}>{contentCreatorType.label }</MenuItem>
                          )
                        })
                    }
                  </Select>
                  <FormHelperText>{localization.get('content_creator_type')}</FormHelperText>

                  <HomeElementCreateDialogTagSelection clearAllTags={this.clearAllTags} tagGroups={this.state.tagGroups} onSelectedTagsChanged={this.onSelectedTagsChanged} />
                </React.Fragment>
              }

              {this.state.dataSource === 'video_content_creation' &&
              <React.Fragment>
                <br/>
                <AsyncSelect
                  name='selectedContentCreatorTypes'
                  id={'selectedContentCreatorTypes'}
                  placeholder={localization.get('conversation.filter_users')}
                  loadingMessage={() => localization.get('loading')}
                  isMulti
                  autoload
                  autoBlur={true}
                  backspaceRemoves={false}
                  noOptionsMessage={() => localization.get('no_options')}
                  value={this.state.selectedContentCreatorTypes}
                  onChange={selectedContentCreatorTypes => this.setState({selectedContentCreatorTypes})}
                  defaultOptions={this.props.contentCreatorTypes}
                  loadOptions={(inputValue, callback) => {
                    callback(this.props.contentCreatorTypes.filter(i =>
                      i.label.toLowerCase().includes(inputValue.toLowerCase())
                    ))
                  }}
                />
                <FormHelperText>{localization.get('content_creator_type')}</FormHelperText>


                <HomeElementCreateDialogTagSelection clearAllTags={this.clearAllTags} contentCreators={this.state.selectedContentCreatorTypes} tagGroups={this.state.tagGroups} onSelectedTagsChanged={this.onSelectedTagsChanged}/>
              </React.Fragment>
              }

              {this.state.dataSource === 'playlist' &&
                <React.Fragment>
                  <br/>
                  <FormHelperText>{localization.get('playlist')}</FormHelperText>
                  <AsyncSelect
                    name='playlist'
                    id={'playlist'}
                    placeholder={localization.get('conversation.filter_users')}
                    loadingMessage={() => localization.get('loading')}
                    autoload
                    autoBlur={true}
                    noOptionsMessage={() => localization.get('no_options')}
                    value={this.state.playlist}
                    onChange={playlist => this.setState({playlist})}
                    defaultOptions={this.state.availablePlaylists}
                    loadOptions={(inputValue, callback) => {
                      callback(this.state.availablePlaylists.filter(i =>
                        i.label.toLowerCase().includes(inputValue.toLowerCase())
                      ))
                    }}
                  />
                  <br/>
                </React.Fragment>
              }

              {this.state.dataSource === 'link' &&

                <TextValidator
                  style={{ width: "100%", marginBottom: "20px" }}
                  label={localization.get('url')}
                  name="link"
                  value={this.state.link}
                  onChange={e => this.setState({link: e.target.value})}
                />
              }
            </FormControl>
            }
            {this.state.dataSource === 'section' &&
            <React.Fragment>
              <br/>
              <br/>
              <FormHelperText>{localization.get('section')}</FormHelperText>
              <AsyncSelect
                name='section'
                id={'section'}
                placeholder={localization.get('section')}
                loadingMessage={() => localization.get('loading')}
                autoload
                autoBlur={true}
                noOptionsMessage={() => localization.get('no_options')}
                value={this.state.section}
                onChange={section => this.setState({section})}
                defaultOptions={this.props.sections}
                loadOptions={(inputValue, callback) => {
                  callback(this.props.sections.filter(i =>
                    i.label.toLowerCase().includes(inputValue.toLowerCase())
                  ))
                }}
              />
              <br/>
            </React.Fragment>
            }

          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCancel} disabled={this.state.submitting}><Close /></Button>
            <Button type="submit"><Done /></Button>
          </DialogActions>
        </ValidatorForm>
      </Dialog>
    )
  }
}

export default HomeElementCreateDialog
